import './Layout.less';
import { ProductFooter } from '@adtech/ui';
import AdBlockerNotification from '@components/AdBlockerNotification';
import Header from '@components/Header';
import Error from '@containers/Error';
import { useAppDispatch, useAppSelector } from '@hooks/useStore';
import { clearError } from '@redux/slices/global';
import { IRootSlice } from '@typings/rootSlice';
import { initTop100Counter } from '@utils/top100Counter';
import React, { useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router';
import { Outlet } from 'react-router-dom';

const Layout: React.FC = () => {
    const mounted = useRef(null);
    const layoutMainRef = useRef<HTMLDivElement>(null);
    const { pathname } = useLocation();
    const dispatch = useAppDispatch();
    const errorCode = useAppSelector((state: IRootSlice) => state.globalSlice.error.code || null);

    useEffect(() => {
        dispatch(clearError());
    }, [pathname]);

    const sendPageView = useCallback(() => {
        window.sberAdsCounter?.trackPageview();
    }, []);

    // Инициализируем счетчики при маунте
    // Отправляем PV только при смене pathname
    useEffect(() => {
        if (!mounted.current) {
            initTop100Counter();
            mounted.current = true;
        } else {
            sendPageView();
            if (!layoutMainRef?.current) return;
            layoutMainRef.current.scrollTo(0, 0);
        }
    }, [pathname]);

    return (
        <div className="layout">
            <div className="layout__header">
                <Header />
            </div>
            <div className="layout__main" ref={layoutMainRef}>
                <div className="layout__content">{errorCode ? <Error /> : <Outlet />}</div>
                <ProductFooter />
            </div>
            <AdBlockerNotification />
        </div>
    );
};

export default Layout;
